export const AI_INSIGHT_KEYS = {
  all: ['ai-insight'] as const,
} as const;
